import { createContext, useState, useEffect, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

// src/theme/theme-provider.tsx
var ThemeContext = createContext(null);
function resolveSystem() {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function ThemeProvider({ store, children }) {
  const [mode, setModeState] = useState(() => store.get());
  const [systemResolved, setSystemResolved] = useState(() => resolveSystem());
  useEffect(() => store.subscribe(setModeState), [store]);
  useEffect(() => {
    if (typeof window === "undefined") return void 0;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const handler = () => setSystemResolved(mq.matches ? "dark" : "light");
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);
  const resolved = mode === "system" ? systemResolved : mode;
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.classList.toggle("dark", resolved === "dark");
    document.documentElement.style.colorScheme = resolved;
  }, [resolved]);
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value: { mode, resolved, setMode: store.set }, children });
}
function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme() must be used inside <ThemeProvider>");
  return ctx;
}

// src/theme/theme-store.ts
function createThemeStore(opts = {}) {
  const key = opts.storageKey ?? "theme";
  const defaultMode = opts.defaultMode ?? "system";
  let current = defaultMode;
  if (typeof localStorage !== "undefined") {
    const saved = localStorage.getItem(key);
    if (saved === "light" || saved === "dark" || saved === "system") current = saved;
  }
  const listeners = /* @__PURE__ */ new Set();
  return {
    get: () => current,
    set: (mode) => {
      current = mode;
      if (typeof localStorage !== "undefined") localStorage.setItem(key, mode);
      listeners.forEach((cb) => cb(mode));
    },
    subscribe: (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    }
  };
}

export { ThemeProvider, createThemeStore, useTheme };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map